import { render } from "./PageLoader.vue?vue&type=template&id=e47b573c&scoped=true"
const script = {}

import "./PageLoader.vue?vue&type=style&index=0&id=e47b573c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e47b573c"]])

export default __exports__